module.exports = __webpack_public_path__ + "../assets/img/1dfcb99a83f624d63393d5f5d4cccf02.jpg";